import { createSelector } from 'reselect'
import getUserAcademicLevel from 'redux/selectors/user/academic_level_selector'
import academicLevelTypes from 'helpers/enums/academicLevelTypes'
import overlayTypes from 'helpers/enums/overlayTypes'
import slideModeTypes from 'helpers/enums/slideModeTypes'

const getLtiData = state => state.lti
const getOverlays = state => state.overlay
const getCurrentView = state => state.ui.currentView
const getNotificationMessage = state => state.user.extra ? state.user.extra.notificationMessage : null
const getFlocabularyMode = state => state.flocabulary.mode

function canSeeOverlay(currentView, overlayViews) {
	return (overlayViews.includes('all') || overlayViews.includes(currentView))
}

const overlay_notification_message_selector = createSelector(
	[ getOverlays, getCurrentView, getNotificationMessage, getLtiData, getUserAcademicLevel, getFlocabularyMode ],
	( overlays, currentView, notificationMessage, ltiData, userAcademicLevel, flocabularyMode) => {
		let overlayType = ''
		const isHigherEdUser = userAcademicLevel === academicLevelTypes.HIGHER_ED
		if (!ltiData.ltiToken && ltiData.teams !== '1' && ltiData.extension !== '1') {
			if (notificationMessage && notificationMessage.showMessage === '1' && notificationMessage.overlayType &&
				canSeeOverlay(currentView, notificationMessage.showIn) && (!isHigherEdUser || notificationMessage.overlayType === overlayTypes.FEATURE_FIRST_LESSON_OVERLAY_ID)
				&& (notificationMessage.overlayType !== overlayTypes.FEATURE_FLOCABULARY_LIMIT_REACHED_OVERLAY_ID || flocabularyMode === slideModeTypes.CREATION)) {
				overlayType = notificationMessage.overlayType
			} else if (overlays.length > 0 && canSeeOverlay(currentView, overlays[0].showIn)) {
				overlayType = overlays[0].overlayType
			}
		}

		return {
			overlayType,
		}
	}
)

export default overlay_notification_message_selector
